import { useEffect } from "react";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const { user, logout, login, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { if (!loading && !user) login(); }, [loading, user, login]);
  if (!user) return null;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="profile-page">
      <h1 className="font-display text-4xl text-[#2C2A29] mb-10">My Profile</h1>
      <div className="bg-white border border-[#EAE3D9] rounded-2xl p-8 flex items-center gap-6" data-testid="profile-card">
        {user.picture ? (
          <img src={user.picture} alt={user.name} className="h-20 w-20 rounded-full border-2 border-[#C5A059]" />
        ) : (
          <div className="h-20 w-20 rounded-full bg-[#8B1E28] text-white flex items-center justify-center text-3xl font-display">
            {user.name?.[0] || "S"}
          </div>
        )}
        <div className="flex-1">
          <h2 className="font-display text-2xl text-[#2C2A29]" data-testid="profile-name">{user.name}</h2>
          <p className="text-sm text-[#8A8480]" data-testid="profile-email">{user.email}</p>
          <p className="text-xs label-small text-[#C5A059] mt-1">{user.role === "admin" ? "Administrator" : "Sumanya Patron"}</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-4 mt-6">
        <Button onClick={() => navigate("/orders")} variant="outline" className="rounded-xl py-6 h-auto border-[#EAE3D9]">My Orders</Button>
        <Button onClick={() => navigate("/wishlist")} variant="outline" className="rounded-xl py-6 h-auto border-[#EAE3D9]">Wishlist</Button>
        <Button onClick={logout} className="btn-primary rounded-xl py-6 h-auto" data-testid="profile-logout">Sign out</Button>
      </div>
    </div>
  );
}
